type StorageType = 'local' | 'session';

function getStorage(type: StorageType): Storage | null {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return type === 'local' ? window.localStorage : window.sessionStorage;
    } catch {
        return null;
    }
}

export function getStorageItem(key: string, type: StorageType = 'local'): string | null {
    const storage = getStorage(type);

    if (!storage) {
        return null;
    }

    try {
        return storage.getItem(key);
    } catch {
        return null;
    }
}

export function setStorageItem(key: string, value: string, type: StorageType = 'local'): void {
    const storage = getStorage(type);

    if (!storage) {
        return;
    }

    try {
        storage.setItem(key, value);
    } catch {
        // Storage unavailable (e.g. Safari Private Browsing) — ignore silently.
    }
}

export function removeStorageItem(key: string, type: StorageType = 'local'): void {
    const storage = getStorage(type);

    if (!storage) {
        return;
    }

    try {
        storage.removeItem(key);
    } catch {
        // Storage unavailable — ignore silently.
    }
}

export const getLocalStorageItem = (key: string): string | null => getStorageItem(key, 'local');

export const setLocalStorageItem = (key: string, value: string): void => setStorageItem(key, value, 'local');

export const removeLocalStorageItem = (key: string): void => removeStorageItem(key, 'local');

export const getSessionStorageItem = (key: string): string | null => getStorageItem(key, 'session');

export const setSessionStorageItem = (key: string, value: string): void => setStorageItem(key, value, 'session');

export const removeSessionStorageItem = (key: string): void => removeStorageItem(key, 'session');
